// 基他或公共信息接口
import request from './base/http'
class Service {
    downloadAcCard(data){
        return request({
        method:'post',
        url:'/api/AcCard/DownloadAcCard',
        data
      })
    }
    //用户信息
    userInfo(){
        return request({
            method:'get',
            url:'/api/User/UserInfo',
        })
    }
    

}
export default new Service()
